export enum SupportedChainId {
  GOERLI = 5,
  ARBITRUM_ONE = 42161,
}

export enum UnsupportedChainId {
  MAINNET = 1,
  OPTIMISM = 10,
  OPTIMISM_GOERLI = 420,
  POLYGON = 137,
  POLYGON_MUMBAI = 80001,
  BINANCE_SMART_CHAIN = 56,
  AVALANCHE = 43114,
  FANTOM_OPERA = 250,
  CELO = 42220,
}

export const CHAIN_IDS_TO_NAMES: { [key: number]: string } = {
  [SupportedChainId.GOERLI]: "Goerli",
  [SupportedChainId.ARBITRUM_ONE]: "Arbitrum",

  [UnsupportedChainId.MAINNET]: "Mainnet",
  [UnsupportedChainId.OPTIMISM]: "Optimism",
  [UnsupportedChainId.OPTIMISM_GOERLI]: "Optimism Goerli",
  [UnsupportedChainId.POLYGON]: "Polygon",
  [UnsupportedChainId.POLYGON_MUMBAI]: "Polygon Mumbai",
  [UnsupportedChainId.BINANCE_SMART_CHAIN]: "Binance Smart Chain",
  [UnsupportedChainId.AVALANCHE]: "Avalanche",
  [UnsupportedChainId.FANTOM_OPERA]: "Fantom Opera",
  [UnsupportedChainId.CELO]: "Celo",
};

export const CHAIN_NAMES_TO_IDS: { [key: string]: number } = {
  goerli: SupportedChainId.GOERLI,
  arbitrum: SupportedChainId.ARBITRUM_ONE,

  mainnet: UnsupportedChainId.MAINNET,
  optimism: UnsupportedChainId.OPTIMISM,
  optimismGoerli: UnsupportedChainId.OPTIMISM_GOERLI,
  polygon: UnsupportedChainId.POLYGON,
  polygonMumbai: UnsupportedChainId.POLYGON_MUMBAI,
  binanceSmartChain: UnsupportedChainId.BINANCE_SMART_CHAIN,
  avalanche: UnsupportedChainId.AVALANCHE,
  fantomOpera: UnsupportedChainId.FANTOM_OPERA,
  celo: UnsupportedChainId.CELO,
};

/**
 * Array of all the supported chain IDs
 */
export const ALL_SUPPORTED_CHAIN_IDS: SupportedChainId[] = Object.values(
  SupportedChainId
).filter((id) => typeof id === "number") as SupportedChainId[];

/**
 * Array of all the unsupported chain IDs
 */
export const ALL_UNSUPPORTED_CHAIN_IDS: UnsupportedChainId[] = Object.values(
  UnsupportedChainId
).filter((id) => typeof id === "number") as UnsupportedChainId[];

export function isSupportedChain(
  chainId: number | null | undefined
): chainId is SupportedChainId {
  return !!chainId && !!SupportedChainId[chainId];
}
